export default __webpack_public_path__ + "static/media/fire-hydrant.5443d6e1.svg";